var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-0"},[_c('div',{staticClass:"print-component"},[(_vm.$store.state.shared.printData)?_c('div',{key:_vm.keyRender,ref:"printRef"},[_c(_vm.getComponent(),{key:_vm.keyRender,tag:"component",attrs:{"info":_vm.info}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }